import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'
import IMask from 'imask'

// Styles
import 'typeface-roboto'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

// Remove security hash adding from Facebook Auth
// https://stackoverflow.com/a/7297873/3320044
if (window.location.hash && window.location.hash == '#_=_') {
  history.pushState('', document.title,
    window.location.pathname + window.location.search)
}

document.addEventListener('turbolinks:load', function() {
  let registration_form = document.getElementById('registration_new')
  if (registration_form) {
    let { admin_name, admin_email, admin_phone, admin_terms_of_service } = registration_form,
    admin_inputs = [
      admin_name, admin_email, admin_phone, admin_terms_of_service
    ].filter( Boolean )

    // Phone input mask and validation
    if (admin_phone) {
      IMask(admin_phone, { mask: '+{38 (0}00) 000-00-00' })
      admin_phone.setAttribute('minLength', 19)
      admin_phone.setAttribute('maxLength', 19)
    }

    // Check form invalidity for registration buttons
    let registrationInvalidity = () => {
      return admin_inputs.some((input)=>{return !input.validity.valid})
    }

    // Disable registration buttons if not all fields are filled    
    let updateRegistrations = () => {
      document.querySelectorAll('a[data-handle="registrations"]').forEach((link)=>{
        link.toggleAttribute('disabled', registrationInvalidity())

        var href = Rails.href(link),
            url = new URL(href)

        if (admin_name)
          url.searchParams.set('name', admin_name.value)
        if (admin_phone)
          url.searchParams.set('phone', admin_phone.value)
        if (admin_email)
          url.searchParams.set('email', admin_email.value)

        link.setAttribute('href', url)
      })
    }
    updateRegistrations()
    admin_inputs.forEach((input)=>{ input.addEventListener('input', updateRegistrations) })
    window.addEventListener('pageshow', updateRegistrations)

    // Show validation errors for click on disabled button 
    document.querySelectorAll('a[data-handle="registrations"]').forEach((link)=>{
      link.addEventListener('click', (e)=>{
        if (registrationInvalidity()) {
          registration_form.reportValidity()
          Rails.stopEverything(e)
          return false
        }
      }, true)
    })
  }
})
